// Cart Update Event After ATC
// Trigger Free Gift Function
// Add/Remove Free Gift
// Trigger rerender sections

const freeGiftFunction = subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
  freeGiftCartUpdate();
});



function freeGiftCartUpdate() {
  const freeGift = window.freeGift.product;
  const freeGiftEnabled = window.freeGift.enabled;
  const freeGiftThreshold = window.freeGift.threshold;

  if (freeGiftEnabled) {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((data) => {
      
        const cartSubtotal = data.total_price / 100;
        const isFreeGiftInCart = data.items.some((item) => item.id == freeGift);
        if (cartSubtotal >= freeGiftThreshold) {
       
          if (!isFreeGiftInCart) {
          setCartStyle()
            addVariantToCart(freeGift, 1);
             console.log('free-gift-fetch-add')
          }
        } else if (cartSubtotal < freeGiftThreshold) {
          if (isFreeGiftInCart) {
          setCartStyle()
            removeVariantFromCart(freeGift);
          }
        }
      });
  }
}

function setCartStyle(){
    if(document.querySelector("#CartDrawer-CartItems")){
        document.querySelector("#CartDrawer-CartItems").style.opacity = "0.5";
        document.querySelector("#CartDrawer-CartItems").style.pointerEvents = "none";
    }
  
    if(document.querySelector(".cart__items")){
        document.querySelector(".cart__items").style.opacity = "0.5";
        document.querySelector(".cart__items").style.pointerEvents = "none";
    }
}

function unsetCartStyle(){
   if(document.querySelector("#CartDrawer-CartItems")){
        document.querySelector("#CartDrawer-CartItems").style.opacity = "1";
        document.querySelector("#CartDrawer-CartItems").style.pointerEvents = "auto";
    }

    if(document.querySelector(".cart-items")){
       document.querySelector(".cart-items").style.opacity = "1";
        document.querySelector(".cart-items").style.pointerEvents = "auto";
    }
}

function addVariantToCart(variant, quantity = 1) {
  let sectionToUpdate = "cart-drawer,cart-icon-bubble";
  let formData = {
    items: [
      {
        id: parseFloat(variant),
        quantity,
      },
    ],
    sections: sectionToUpdate,
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            parsedState: response,
          },
        })
      );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function removeVariantFromCart(variant) {
  let sectionToUpdate = "cart-drawer,cart-icon-bubble";
  let updates = {
    [variant]: 0,
  };

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates, sections: sectionToUpdate }),
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            parsedState: response,
            action: "remove",
            variant: variant,
          },
        })
      );
    })
    .finally(() => {
      // Set Cart To Have is empty class to show empty cart properly
      if (
        document
          .querySelector("cart-drawer")
          .querySelector(".drawer__inner-empty")
      ) {
        document.querySelector("cart-drawer").classList.add("is-empty");
      }

      setTimeout(() => {
        if (document.querySelector("cart-items")) {
          console.log("yes");
          if (
            document
              .querySelector("cart-items")
              .querySelector(".cart__warnings")
          ) {
            console.log("is-empty");
            document.querySelector("cart-items").classList.add("is-empty");
            document
              .querySelector("#main-cart-footer")
              .classList.add("is-empty");
          }
        }
      }, "300");
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
